 <div class="gantt_activity_bars_area" [ngStyle]="{ 'height': containerHeight + 'px', 'width': containerWidth + 'px' }">
    <div #bar class="gantt_activity_line" *ngFor="let task of ganttService.groupData(tasks); let i = index" [ngStyle]="drawBar(task, i)">
        <div class="gantt_activity_progress" [ngStyle]="drawProgress(task, bar)"></div>
        <div class="gantt_activity_progress_drag" style="left: 518px"></div>
        <div class="gantt_activity_content"></div>
        <div class="gantt_activity_link_control gantt_activity_right" style="height: 26px; line-height: 30px">
            <div class="gantt_link_point"></div>
        </div>
        <div class="gantt_activity_link_control gantt_activity_left" style="height: 26px; line-height: 30px">
            <div class="gantt_link_point"></div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/gantt-chart/gantt-activity/activity-bars/activity-bars.component.html